import { FileEntry, isFileUploadInfo } from 'src/shared/design-system/FileUpload/FileUpload';
import Notifications from 'src/shared/Notifications';

export const getPhotoPublicUrl = (file?: FileEntry) => {
  if (!file) {
    return undefined;
  }
  if (!isFileUploadInfo(file)) {
    Notifications.error(file.error);
    return null;
  }
  return file.signedUrl.split('?')[0];
};
